// @flow
import { useQuery, type QueryResult } from 'react-query';

import useClientId from 'common/hooks/useClientId';

import { Carriers } from 'platform/settings/modules/orchestration/models/internal/Carriers';
import { carriers as carriersApi } from 'platform/settings/modules/orchestration/api';

const useGetCarriers = (): QueryResult<Carriers> => {
    const clientId = useClientId();

    return useQuery({
        queryKey: ['client', clientId, 'carriers'],
        queryFn: async () => {
            const data = await carriersApi.fetch({ clientId });

            return Carriers.fromJS(data);
        },
        refetchOnWindowFocus: false
    });
};

export default useGetCarriers;
